<template>
  <main>
    <section class="video-intro">
      <h1>Contrology Event Video</h1>
    </section>

    <nav>
      <router-link to="event-videos" title="See all event videos"><img src="@/assets/icon-standard-arrow-left.svg" alt="Back arrow icon">all videos</router-link>
    </nav>

    <div class="video-container">
      <iframe title="This is an embedded iframe video" width="996" height="560" src="https://www.youtube.com/embed/HFe2Al6bk1Q" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>

    <div class="wide-flex-wrapper">
      <section class="video-description">
        <h2>Contrology Reformer Relay</h2>
        <p>Original Air Date: May 16, 2020</p>
        <p>Four world-class instructors. One awesome apparatus. This is our globally spiced Contrology® Reformer Relay! Hosted by our own Ana Caban, each of our star teachers will handle a different "leg" of our workout relay:</p>
        <ol>
          <li><a href="https://www.instagram.com/exhalepilateslondon/" style="color:black">Gaby Noble</a> (London, UK): Footwork through Coordination</li>
          <li><a href="https://www.instagram.com/glopilatesemotion/" style="color:black">Gloria Gasperi</a> (Cinque Terra, Italy): Long Box Series through Stomach Massage Series</li>
          <li><a href="https://www.instagram.com/contrologycohort/" style="color:black">Jon Owen</a> (New York City, NY): Short Box Series through Frog/Leg Circles</li>
          <li><a href="https://www.instagram.com/jcvitalitymethod/" style="color:black">Joel Crosby</a> (Duluth, Georgia): Knee Stretch Series through Russian Splits</li>
        </ol>
        <p>Stay tuned after the Relay for a Q&A with Ana, our 4 instructors and special guests. See how the Contrology Apparatus makes a difference in their work!</p>
        <p>Runtime: 60 minutes (Relay), 80 minutes total</p>
      </section>

      <hr>

      <section class="video-speakers">
        <h3>Featured Speakers</h3>
        <div class="video-speakers-container">
          <div class="video-speaker">
            <img src="@/assets/gaby@1x.jpg" srcset="@/assets/gaby@2x.jpg 2x" alt="Gaby headshot">
            <div class="video-speaker-content">
              <p style="white-space:nowrap"><b>Gaby Noble</b></p>
              <p style="white-space:nowrap"><a href="https://exhalepilateslondon.com/">Exhale Pilates</a></p>
            </div>
          </div>

          <div class="video-speaker">
            <img src="@/assets/gloria@1x.jpg" srcset="@/assets/gloria@2x.jpg 2x" alt="Gloria headshot">
            <div class="video-speaker-content">
              <p style="white-space:nowrap"><b>Gloria Gasperi</b></p>
              <p style="white-space:nowrap"><a href="https://www.studiopilatessarzana.it/it/">Studio Pilates</a></p>
            </div>
          </div>

          <div class="video-speaker">
            <img src="@/assets/jon@1x.jpg" srcset="@/assets/jon@2x.jpg 2x" alt="Jon headshot">
            <div class="video-speaker-content">
              <p style="white-space:nowrap"><b>Jon Owen</b></p>
              <p style="white-space:nowrap"><a href="https://www.contrologycohort.com/">The Contrology Cohort</a></p>
            </div>
          </div>

          <div class="video-speaker">
            <img src="@/assets/joel@1x.jpg" srcset="@/assets/joel@2x.jpg 2x" alt="Joel headshot">
            <div class="video-speaker-content">
              <p style="white-space:nowrap"><b>Joel Crosby</b></p>
              <p style="white-space:nowrap"><a href="http://www.vitalitymethod.com/vitalityfootweights.html">Vitality Method Studio</a></p>
            </div>
          </div>
        </div>
      </section>
    </div>
    
  </main>
</template>

<script>
  export default {
    name: "videorelay",

    metaInfo: {
      title: "Classical Pilates - Reformer Workout Relay with 4 All Star Instructors",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content: "Enjoy this Contrology Reformer workout relay with 4 all star instructors walking through different leg series. Watch this inspiring workout series."
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/videorelay.jpg"
        }
      ]
    },
  }
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  flex-flow: column nowrap;
  margin: 20px 0 30px;
  max-width: 996px;
  margin: 0 auto;
}

nav a {
  text-transform: uppercase;
  font-family: var(--rob);
  font-size: 1.125rem;
  line-height: 1.278;
  font-weight: 700;
  color: #333;
  text-decoration: none;
  padding: 7px 0;
  display: flex;
  justify-content: flex-start;
}

nav img {
  margin-right: 15px;
}

.video-container { 
  position: relative; 
  padding-bottom: 56.25%; 
  padding-top: 30px; 
  height: 0; 
  overflow: hidden; 
  max-width: 996px;
  margin: 0 auto 40px;
}

.video-container iframe,
.video-container object,
.video-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%;
  max-height: 560px;
}

.video-description p {
  font-size: 0.9375rem;
  line-height: 1.4667;
}

hr {
  border: 0;
  border-top: 1px solid #333;
  width: 100%;
  margin: 30px 0;
}

h3 {
  text-align: left;
}

.video-speakers {
  width: 275px;
  margin: 0 auto;
}

.video-speaker {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  margin-bottom: 12px;
}

.video-speaker img {
  width: 100px;
  height: 100px;
  display: block;
  margin-right: 12px;
}

.video-speaker-content p {
  margin: 0 0 10px 0;
}

.video-speaker-content p a {
  color: #000;
}

ol li {
  margin: 10px 0;
}

@media only screen and (max-width:374px) {
  .video-speakers {
    width: 250px;
    margin: -10px
  }
}

@media only screen and (min-width:800px) {
  .video-intro {
    margin: 0 auto;
  }

  .wide-flex-wrapper {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
  }

  hr {
    display: none;
  }

  .video-description {
    margin-right: 40px;
  }
}

@media only screen and (min-width:955px) {
  .video-intro {
    max-width: 650px;
  }
}

@media only screen and (min-width:1080px) {
  .video-container { 
    padding-bottom: 0;
    height: 560px;
  }
}
</style>